import { Button, type ButtonAttributes, type ButtonProps } from "@repo/skapa";
import { useState } from "react";

export const LoadingButton = ({
  onClick,
  ...props
}: ButtonProps & ButtonAttributes) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  return (
    <Button
      {...props}
      onClick={async (e: any) => {
        e.preventDefault();
        e.stopPropagation();

        if (onClick === undefined) {
          return;
        }

        setIsLoading(true);
        try {
          // eslint-disable-next-line @typescript-eslint/await-thenable
          await onClick(e);
        } finally {
          setIsLoading(false);
        }
      }}
      loading={isLoading}
    />
  );
};
